import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface LibraryEmptyStateProps {
  onClearFilters: () => void;
}

export default function LibraryEmptyState({ onClearFilters }: LibraryEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="w-16 h-16 rounded-2xl bg-stone-100 flex items-center justify-center mb-5">
        <Icon name="BookOpenIcon" size={28} className="text-stone-400" />
      </div>
      <h3 className="font-semibold text-stone-700 text-lg mb-2">No lessons match your filters</h3>
      <p className="text-stone-500 text-sm max-w-xs mb-6">
        Try adjusting your grade, topic, or SDG filters to find lessons that fit your classroom.
      </p>
      <button
        onClick={onClearFilters}
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 active:scale-95 transition-all duration-150"
      >
        <Icon name="ArrowPathIcon" size={16} />
        Clear All Filters
      </button>
    </div>
  );
}